// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"2375e0d1","453":"af8695d7","674":"101506ea"}[chunkId] + ".chunk.js";
};